<div class="sb-sidebar">
    <!-- WEATHER WIDGET -->
    <mat-card>
        <!-- FRONT -->
        <div>
            <!-- CARD HEADER -->
            <div class="pl-16 pr-8 pt-16 d-flex flex-row align-items-center justify-content-between">
                <div class="px-2 pt-2 h4 d-flex flex-row align-items-start align-items-center">
                    <mat-icon class="sb-secondary-text mr-8">place</mat-icon>
                    <span class="sb-small-text sb-secondary-text">Nairobi</span>
                </div>
                <div>
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="more">
                        <mat-icon class="sb-secondary-text">more_vert</mat-icon>
                    </button>
                    <mat-menu #moreMenu="matMenu">
                        <button mat-menu-item aria-label="Flip widget">
                            Details
                        </button>
                    </mat-menu>
                </div>
            </div>
            <!-- TEMP TODAY -->
            <div class="py-4 d-flex flex-column align-items-center">
                <div class="d-flex flex-row align-items-center">
                    <span class="mat-display-2 m-0 font-weight-300 sb-secondary-text">
                        <i class="fa fa-cloud-rain"></i>
                        <span class="ml-4">22</span>
                    </span>
                    <span class="font-size-48 font-weight-300 sb-hint-text sb-text-super ml-8">°</span>
                    <span class="mat-display-2 mb-0 font-weight-300 sb-hint-text ng-binding">C</span>
                </div>
            </div>
            <!-- WIND & RAIN PROBABILITY -->
            <div class="d-flex justify-content-between align-items-center py-2 border-full border-bottom border-top">
                <div class="d-flex align-items-start align-items-center justify-content-center ml-1">
                    <i class="fa fa-wind mr-2 pl-4"></i>
                    <small class="font-gray-500">12</small>
                    <small class="sb-secondary-text">KMH</small>
                </div>
                <div class="d-flex flex-row align-items-start align-items-center">
                    <i class="fa fa-compass mr-2"></i>
                    <small>NW</small>
                </div>
                <div class="d-flex flex-row align-items-start align-items-center">
                    <i class="fa fa-tint mr-2"></i>
                    <small class="font-gray-500">98</small>
                    <small class="sb-secondary-text pr-4">%</small>
                </div>
            </div>
            <!-- FORECAST -->
            <div class="py-16 mt-3 px-4">
                <div class="d-flex justify-content-between align-items-center py-2">
                    <span class="sb-smaller-text sb-text-gray-800">Sunday</span>
                    <div class="d-flex flex-row align-items-start align-items-center small">
                        <i class="fa fa-cloud mr-2"></i>
                        <span class="sb-small-text">21</span>
                        <span class="sb-small-text font-weight-300 sb-secondary-text sb-text-super">&deg;</span>
                        <span class="sb-small-text font-weight-300 sb-secondary-text">C</span>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2">
                    <span class="sb-smaller-text sb-text-gray-800">Monday</span>
                    <div class="d-flex flex-row align-items-start align-items-center small">
                        <i class="fa fa-cloud-sun mr-2"></i>
                        <span class="sb-small-text">19</span>
                        <span class="sb-small-text font-weight-300 sb-secondary-text sb-text-super">&deg;</span>
                        <span class="sb-small-text font-weight-300 sb-secondary-text">C</span>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2">
                    <span class="sb-smaller-text sb-text-gray-800">Tuesday</span>
                    <div class="d-flex flex-row align-items-start align-items-center small">
                        <i class="fa fa-cloud-showers-heavy mr-2"></i>
                        <span class="sb-small-text">22</span>
                        <span class="sb-small-text font-weight-300 sb-secondary-text sb-text-super">&deg;</span>
                        <span class="sb-small-text font-weight-300 sb-secondary-text">C</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- / FRONT -->
    </mat-card>
    <!-- / WEATHER WIDGET -->
</div>